

















































































import Vue from 'vue';
import { SelectableAmount } from '@/interfaces/payment/selectableAmount';
import TaxReductionInformationComponent from '@/components/TaxReductionInfoComponent.vue';

export default Vue.extend({
  components: { TaxReductionInformationComponent },
  props: {
    value: {
      type: [String, Number],
      default: "",
    },
    selectableAmounts : {
      type: Array as () => Array<SelectableAmount>,
      default: () => [],
    },
    max: {
      type: Number,
      default: null,
    },
    min: {
      type: Number,
      default: null,
    },
    adminFee: {
      type: Number,
      default: null,
    },
    // todo - Do not show this for direct charities. Handle this when adding the component to the donation flow
    feeRegulationUrl: {
      type: String,
      default: "https://pennybridge.org/avgift-pennybridge/",
    },
    displayFee: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      customDonationAmount: null,
      donationAmount: this.value,
      hideFee: true,
      errorText: null,
      sortedSelectableAmounts: [] as SelectableAmount[],
    };
  },
  computed: {
    showError(): boolean {
      return !!this.errorText;
    },
    hasSelectableAmounts(): boolean {
      return !!this.selectableAmounts && this.selectableAmounts.length > 0;
    },
  },
  watch: {
    customDonationAmount(value: number | null) {
      if (!!value) {
        let hasValidCustomAmount: boolean = this.validateDonationAmount(value);
        if (!hasValidCustomAmount) {
          this.errorText = hasValidCustomAmount;
        } else {
          this.errorText = null;
          this.donationAmount = value;
        }
      }
    },
    donationAmount(value) {
      this.$emit('input', value);
    },
    adminFee() {
      this.hideFee = !this.adminFee || this.adminFee === 0 || !this.displayFee
    },
    displayFee() {
      this.hideFee = !this.adminFee || this.adminFee === 0 || !this.displayFee
    },
    value(newVal) {
      this.donationAmount = newVal;
    }
  },
  mounted() {
    this.hideFee = !this.adminFee || this.adminFee === 0 || !this.displayFee;
    this.sortedSelectableAmounts = this.selectableAmounts.sort((a: SelectableAmount, b: SelectableAmount) => {
      return a.id - b.id;
    });
  },
  methods: {
    t(label: string): string {
      const $te: any = (this as any).$te.bind(this);
      const $t: any = (this as any).$t.bind(this);
      return $te(label) ? $t(label) : undefined;
    },
    selectDonationAmount(selectedAmount: SelectableAmount) {
      this.donationAmount = selectedAmount.amount
      this.customDonationAmount = null;
    },
    validateDonationAmount(value: any) {
      const donationAmount = parseInt(value);
      const trueDonationAmount = parseFloat(value);
      if (typeof donationAmount !== 'number') {
        return this.$t('validation.numeric');
      } else if (!Number.isInteger(trueDonationAmount)) {
        return this.$t('validation.nonInteger');
      } else if (/^\d+\.\d+$/.test(value)) { // if the value is an integer, but of a bad form (e.g. 10.0)
        return this.$t('validation.hasDecimal');
      } else if (!!this.max && this.max < donationAmount) {
        return this.$t('validation.maxValue', {max: this.max});
      } else if (!!this.min && donationAmount < this.min) {
        return this.$t('validation.minValue', {min: this.donationMinAmount});
      }

      return true;
    },
  },
});
